import { queryGenerator } from "../../hooks/queries/queries";

import { getAllFinancialHelps } from "./services";

export const useGetAllHelps = queryGenerator(getAllFinancialHelps);
